export function minutesToSeconds(waiting_time) {
  return waiting_time * 60;
}

export function metersToKilometers(meters) {
  return Math.round((meters / 1000) * 10) / 10;
}
